@if (geometry(); as geometry) {
  <div class="center-cheat-sheet__overlay" [attr.aria-label]="label()">
    @for (annotation of annotations(); track annotation.center) {
      @if (geometry.anchors[annotation.center]; as anchor) {
        <div
          class="center-cheat-sheet__annotation"
          [class.center-cheat-sheet__annotation--left]="annotation.side === 'left'"
          [class.center-cheat-sheet__annotation--right]="annotation.side === 'right'"
          [attr.data-center]="annotation.center"
          [style.left.px]="annotationX(annotation, anchor)"
          [style.top.px]="annotationY(annotation, anchor)"
          [style.width.px]="annotation.width"
        >
          <hd-center-mini-card
            [center]="annotation.center"
            [variant]="annotation.variant"
            [isOpen]="annotation.isOpen"
            [themeOnOwnLine]="annotation.themeOnOwnLine"
            [activations]="activations()"
            presentation="cheat-sheet"
          />
        </div>
      }
    }
  </div>
}
